import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center flex-col gap-12" }
const _hoisted_2 = { class: "grid grid-cols-1 xl:grid-cols-2 gap-5 items-center container mx-auto px-4 py-20" }
const _hoisted_3 = { id: "hero-title" }
const _hoisted_4 = { class: "w-24 h-24 opacity-10 -mb-10" }
const _hoisted_5 = { class: "grid grid-cols-4 gap-1.5" }
const _hoisted_6 = ["initial", "enter"]
const _hoisted_7 = ["initial", "enter"]
const _hoisted_8 = { class: "w-full xl:absolute flex justify-end mt-8" }
const _hoisted_9 = { class: "top-0 left-0 -mt-14 w-24 h-24 opacity-10" }
const _hoisted_10 = { class: "grid grid-cols-4 gap-1.5" }
const _hoisted_11 = {
  id: "how-works",
  class: "w-full how-works mt-20 flex justify-center items-center flex-col"
}
const _hoisted_12 = ["initial"]
const _hoisted_13 = { class: "relative span-jost text-4xl flex flex-col items-center justify-center gap-1 mb-10" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "bg-h-secondary-500 h-1 w-6/12 rounded-full" }, null, -1)
const _hoisted_15 = { class: "w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 items-center gap-5 px-5 lg:px-0" }
const _hoisted_16 = ["initial", "enter"]
const _hoisted_17 = { class: "bg-h-primary-50 group-hover:bg-h-primary-100 rounded-2xl p-5 w-fit" }
const _hoisted_18 = { class: "text-h-primary-500" }
const _hoisted_19 = { class: "-mt-2 text-h-neutral-500" }
const _hoisted_20 = {
  id: "partners",
  class: "mt-20 container mx-auto flex flex-col justify-center items-center px-16"
}
const _hoisted_21 = ["initial"]
const _hoisted_22 = { class: "relative span-jost text-4xl flex flex-col items-center justify-center gap-1" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "bg-h-secondary-500 h-1 w-6/12 rounded-full" }, null, -1)
const _hoisted_24 = {
  key: 0,
  class: "flex flex-wrap items-center justify-center w-full mt-16 mb-24 opacity-50 gap-12"
}
const _hoisted_25 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroComponent = _resolveComponent("HeroComponent")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _directive_motion = _resolveDirective("motion")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...Array(16)], (_, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "w-3 h-3 bg-gray-400 rounded-full"
              }))
            }), 128))
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("h1", {
          class: "mt-8 text-6xl lg:text-7xl font-[500] text-h-primary-900",
          initial: _ctx.initial.left,
          enter: _ctx.enter
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
              pt: "Porque aprender",
              en: "Because learning",
            })) + " " + _toDisplayString(_ctx.$t("labels.generic", {
              pt: "pode ser do seu jeito e no seu ritmo.",
              en: "can be your way and at your pace",
            })), 1)
        ], 8, _hoisted_6)), [
          [_directive_motion]
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", {
        id: "hero-image",
        class: "justify-self-end",
        initial: _ctx.initial.right,
        enter: _ctx.enter
      }, [
        _createVNode(_component_HeroComponent),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...Array(16)], (_, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "w-3 h-3 bg-h-primary-300 rounded-full"
                }))
              }), 128))
            ])
          ])
        ])
      ], 8, _hoisted_7)), [
        [_directive_motion]
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _withDirectives((_openBlock(), _createElementBlock("h3", {
        initial: _ctx.initial.left,
        enter: {
          opacity: 1,
          x: 0,
          transition: {
            stiffness: 30,
            delay: 500,
          },
        }
      }, [
        _createElementVNode("span", _hoisted_13, [
          _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", { pt: "Como funciona?", en: "How it works" })) + " ", 1),
          _hoisted_14
        ])
      ], 8, _hoisted_12)), [
        [_directive_motion]
      ]),
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.texts, (text, i) => {
          return (_openBlock(), _createElementBlock("div", { key: text }, [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "bg-white shadow-md rounded-md p-10 relative group hover:-mt-2 hover:shadow-xl flex flex-col justify-center gap-5 items-center text-center !min-h-[330px] transition-all",
              initial: _ctx.initial.left,
              enter: {
              opacity: 1,
              x: 0,
              transition: {
                stiffness: 30,
                delay: (i + 1) * 300,
              },
            }
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_v_icon, {
                  name: text.image,
                  scale: 2,
                  class: "text-h-primary-500"
                }, null, 8, ["name"])
              ]),
              _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.$t("labels.generic", { pt: text.title, en: text.titleEN })), 1),
              _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("labels.generic", { pt: text.text, en: text.textEN })), 1)
            ], 8, _hoisted_16)), [
              [_directive_motion]
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _withDirectives((_openBlock(), _createElementBlock("h3", {
        initial: _ctx.initial.left,
        visible: {
          opacity: 1,
          x: 0,
          transition: {
            stiffness: 30,
          },
        }
      }, [
        _createElementVNode("span", _hoisted_22, [
          _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", { pt: "Parceiros", en: "Partners" })) + " ", 1),
          _hoisted_23
        ])
      ], 8, _hoisted_21)), [
        [_directive_motion]
      ]),
      (_ctx.partners?.length !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (img, index) => {
              return (_openBlock(), _createElementBlock("img", {
                class: "invert filter w-40 h-fit mx-5",
                key: index,
                src: _ctx.getFileUrl(img),
                loading: "lazy"
              }, null, 8, _hoisted_25))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}